module.exports = __webpack_public_path__ + "img/forward-fast.9007eabe.svg";